import { useCurrentUser } from '@pella/react-current-user';

const CAN_DELETE_SETUPS = new Set(['ADMINISTRATOR', 'IT_ADMIN_V2', 'SETUPS_V2']);

/**
 * Custom hook to determine user authorization levels
 * @returns {{ canDeleteSetups: boolean }}
 */
export const useAuth = () => {
  const { roles } = useCurrentUser();

  const canDeleteSetups = roles.some((role) => CAN_DELETE_SETUPS.has(role));

  return { canDeleteSetups };
};
